module.exports = __webpack_public_path__ + "img/BrittaMohr_140x_140x_rund.b7234664.jpg";